import { toast } from "react-toastify";

import confirmParcisionOptInBidRequest from "../../apis/prod/parcision/confirm_optin_bid_contract";
import confirmParcisionCloseOutRequest from "../../apis/prod/parcision/confirm_closeout_contract";
import confirmParcisionBulkCloseOutRequest from "../../apis/prod/parcision/confirm_bulk_closeout_contract";
import confirmParcisionBidRequest from "../../apis/prod/parcision/confirm_bid_contract";

import confirmOptInPortfolioParcision from "../../apis/prod/parcision/confirm_optin_update_portfolio";
import confirmCloseOutPortfolioParcision from "../../apis/prod/parcision/confirm_closeout_portfolio";
import confirmUpdatePortfolioParcision from "../../apis/prod/parcision/confirm_update_portfolio";

import { sentryWrappedException } from "~/utils/Utils";

export async function optInParcision(
  cid: number,
  gparam: string,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  wager: number,
  description: string
) {
  const toastId = toast.info(`Opting in ${gparam} with Parcision wallet.`, { autoClose: false });

  try {
    // COMPLETE THE TRANSACTION
    const contract_data = await confirmParcisionOptInBidRequest(
      cid,
      estimate1,
      estimate2,
      estimate3,
      wager,
      description
    );

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });
    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function closeOutParcision(cid: number, gparam: string) {
  const toastId = toast.info(`Closing out ${gparam} with Parcision wallet.`, { autoClose: false });

  try {
    // COMPLETE THE TRANSACTION
    const contract_data = await confirmParcisionCloseOutRequest(cid);

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function bulkCloseOutParcision() {
  const toastId = toast.info(`Closing out BULK with Parcision wallet.`, { autoClose: false });

  try {
    // COMPLETE THE TRANSACTION
    const contract_data = await confirmParcisionBulkCloseOutRequest();

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return "passed";
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function submitBidParcision(
  cid: number,
  gparam: string,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  wager: number,
  description: string
) {
  const toastId = toast.info(`Submitting ${gparam} Bid with Parcision wallet.`, { autoClose: false });
  try {
    // COMPLETE TRANSACTION
    const contract_data = await confirmParcisionBidRequest(cid, estimate1, estimate2, estimate3, wager, description);

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function submitOptInBidParcision(
  cid: number,
  gparam: string,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  wager: number,
  description: string
) {
  const toastId = toast.info(`Submitting ${gparam} Bid with Parcision wallet.`, { autoClose: false });
  try {
    // COMPLETE TRANSACTION
    const contract_data = await confirmParcisionOptInBidRequest(
      cid,
      estimate1,
      estimate2,
      estimate3,
      wager,
      description
    );

    const message = contract_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return contract_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function optInPortfolioParcision(
  pid: number,
  phash: string,
  pverified: boolean,
  rhash: string,
  rverified: boolean,
  description: string
) {
  const toastId = toast.info(`Submitting Update with Parcision wallet.`, { autoClose: false });
  try {
    // COMPLETE TRANSACTION
    const portfolio_data = await confirmOptInPortfolioParcision(pid, phash, pverified, rhash, rverified, description);

    const message = portfolio_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return portfolio_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function closeOutPortfolioParcision(pid: number) {
  const toastId = toast.info(`Closing out with Parcision wallet.`, { autoClose: false });

  try {
    // COMPLETE THE TRANSACTION
    const portfolio_data = await confirmCloseOutPortfolioParcision(pid);

    const message = portfolio_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return portfolio_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}

export async function updatePortfolioParcision(
  pid: number,
  phash: string,
  pverified: boolean,
  rhash: string,
  rverified: boolean,
  description: string
) {
  const toastId = toast.info(`Submitting Update with Parcision wallet.`, { autoClose: false });
  try {
    // COMPLETE TRANSACTION
    const portfolio_data = await confirmUpdatePortfolioParcision(pid, phash, pverified, rhash, rverified, description);

    const message = portfolio_data.message;

    if (message.includes("Error")) {
      sentryWrappedException(message);
      toast.update(toastId, {
        type: toast.TYPE.ERROR,
        autoClose: 3000,
        render: () => <div>{message.split(":")[1].trim()}</div>,
      });
      if (message.toLowerCase().indexOf("low funds") >= 0) {
        return "Low Funds";
      }
      return null;
    }

    toast.update(toastId, {
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
      render: () => <div>{message}</div>,
    });

    return portfolio_data;
  } catch (error) {
    sentryWrappedException(error);
    toast.update(toastId, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      render: () => <div>{error.message}</div>,
    });
    throw error;
  }
}
